<div #mainDiv_ll_cms_providerinfo_dg class="main-container">
  <div #horzTabs_ll_cms_providerinfo_dg class="horz-tabs" *ngIf="bundle.showHorzTabs">
    <!-- Horizontal tabs content, if needed -->
  </div>
  <div class="grid-container" [style.width.px]="bundle.remainingW" [style.height.px]="bundle.remainingH" [style.top.px]="bundle.remainingY">
    <div *ngIf="isLoading" class="loading" role="alert" aria-live="polite">Loading...</div>
    <div *ngIf="error" class="error" role="alert" aria-live="assertive">{{ error }}</div>
    <table *ngIf="!isLoading && !error" class="cms-grid" role="grid" aria-label="CMS Provider Information">
      <thead>
        <tr>
          <th *ngFor="let col of getColumns()"
              [attr.aria-sort]="getSortState(col.columnCode)"
              (click)="sortBy(col.columnCode)"
              scope="col"
              class="sortable">
            {{ col.Label }}
            <span class="sort-icon" *ngIf="sortColumn === col.columnCode">
              {{ sortDirection === 'asc' ? '↑' : '↓' }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="bundle.records.length === 0">
          <td [attr.colspan]="getColumns().length" class="no-data">No data available</td>
        </tr>
        <tr *ngFor="let record of bundle.records">
          <td *ngFor="let col of getColumns()"
              [ngClass]="getCellBackgroundClass(record, col.columnCode)">
            {{ formatCell(record, col.columnCode) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
